// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aS-1i","footer":"styles_footer__3QN5A"};